module.exports = __webpack_public_path__ + "static/img/iCCS-icon.4f460a88.png";